import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Staking: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon viewBox="0 0 40 40" sx={{ width: '40px', height: '40px', fill: 'none', ...sx }} {...props}>
    <path
      d="M19.9891 13.998C19.9891 15.6562 16.6307 16.9993 12.4875 16.9993C8.34277 16.9993 4.98438 15.6562 4.98438 13.998"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.486 23.0012C8.34277 23.0012 4.98438 21.6582 4.98438 20"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.997 7.99414H19.9985V16.9979"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4875 29.0032C8.34427 29.0032 4.98438 27.6601 4.98438 26.002"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="12.4875"
      cy="7.99539"
      rx="7.50312"
      ry="3.00125"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.98993 7.99414V26.0016" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M36.0006 9.09968L36.9298 1.66602H30.9649H25L25.4458 8.7987C25.6028 11.3102 27.1605 13.5192 29.4733 14.5105L30.614 14.9993L32.0116 14.4004C34.1884 13.4675 35.7069 11.4497 36.0006 9.09968Z"
      stroke="#B4EB56"
      strokeWidth="2"
    />
    <path
      d="M28.8516 8.28101L29.8846 9.31404C30.2731 9.70258 30.9248 9.61532 31.1974 9.13824L33.0621 5.875"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M17.0078 23V29" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <ellipse
      cx="24.5031"
      cy="23.0012"
      rx="7.50312"
      ry="3.00125"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M32.0156 23H32.0171V29" stroke="#B4EB56" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M32.0047 29.0039C32.0047 30.6621 28.6464 32.0052 24.5031 32.0052C20.3584 32.0052 17 30.6621 17 29.0039"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const StakingDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon viewBox="0 0 32 32" sx={{ width: '24px', height: '24px', fill: 'none', ...sx }} {...props}>
    <path
      d="M15.996 11.1973C15.996 12.5238 13.3093 13.5983 9.99469 13.5983C6.67891 13.5983 3.99219 12.5238 3.99219 11.1973"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99349 18.401C6.67891 18.401 3.99219 17.3266 3.99219 16"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0023 6.39648H16.0035V13.5995"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99469 23.2037C6.68011 23.2037 3.99219 22.1293 3.99219 20.8027"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="9.99469"
      cy="6.39514"
      rx="6.0025"
      ry="2.401"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.98726 6.39648V20.8025" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M30.0006 9.43366L30.9298 2H24.9649H19L19.4458 9.13269C19.6028 11.6441 21.1605 13.8532 23.4733 14.8445L24.614 15.3333L26.0116 14.7344C28.1884 13.8015 29.7069 11.7837 30.0006 9.43366Z"
      stroke="#090C18"
      strokeWidth="2"
    />
    <path
      d="M22.8516 8.615L23.8846 9.64803C24.2731 10.0366 24.9248 9.9493 25.1974 9.47222L27.0621 6.20898"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M13.6094 20V24.8" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <ellipse
      cx="19.6041"
      cy="20.0006"
      rx="6.0025"
      ry="2.401"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M25.6094 20H25.6106V24.8" stroke="#090C18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M25.6054 24.8027C25.6054 26.1293 22.9186 27.2037 19.6041 27.2037C16.2883 27.2037 13.6016 26.1293 13.6016 24.8027"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
